/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  HttpClient,
  HttpErrorResponse,
  HttpParams,
  type HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { getRestEndpoint } from 'src/app/helpers/api-url';
import {
  IGroupEnrollment,
  IGroupEnrollmentPayer,
  IGroupEnrollmentPayersParams,
  IGroupEnrollmentUpdate,
} from 'src/app/shared/interfaces/group-enrollment/group-enrollment.interface';

@Injectable({
  providedIn: 'root',
})
export class GroupEnrollmentService {
  constructor(private http: HttpClient) {}

  createGroupEnrollment(groupEnrollment: IGroupEnrollment): Observable<any> {
    return this.http.post(
      `${getRestEndpoint()}/enrollment/groups`,
      groupEnrollment,
    );
  }

  editGroupEnrollment(
    groupEnrollment: IGroupEnrollmentUpdate,
  ): Observable<any> {
    const insuranceCompanyRecId: number = groupEnrollment.seqNo;
    return this.http.put(
      `${getRestEndpoint()}/enrollment/groups/${insuranceCompanyRecId}`,
      groupEnrollment,
    );
  }

  getGroupEnrollmentPayers(
    groupEnrollmentPayerBody?: IGroupEnrollmentPayersParams,
  ): Observable<IGroupEnrollmentPayer[]> {
    const params = {
      ...groupEnrollmentPayerBody,
    };

    let httpParams = new HttpParams();

    for (const k of Object.keys(params)) {
      if (Array.isArray(params[k]) && params[k].length > 1) {
        for (const element of params[k]) {
          httpParams = httpParams.append(
            k,
            element as boolean | number | string,
          );
        }
      } else {
        httpParams = httpParams.append(
          k,
          params[k] as boolean | number | string,
        );
      }
    }

    return this.http
      .get<
        IGroupEnrollmentPayer[]
      >(`${getRestEndpoint()}/enrollment/payers`, { params: httpParams })
      .pipe(
        catchError((error: HttpErrorResponse) => {
          return throwError(() => {
            return error;
          });
        }),
      );
  }

  DownloadFile(
    filePath: string,
    _fileType: string,
  ): Observable<HttpResponse<Blob>> {
    const input = encodeURIComponent(filePath);

    return this.http
      .get(`${getRestEndpoint()}/enrollment/download/` + input, {
        responseType: 'blob',
        observe: 'response',
      })
      .pipe(
        catchError((error: HttpErrorResponse) => {
          return throwError(() => {
            return error;
          });
        }),
      );
  }
}
